var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{class:[
    'device-box',
    'xs12',
    _vm.isIpadMini ? 'md12' : 'md6',
    'lg4' ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }